import { useEditChatroomMutation } from '@pba/react-chat-core';
import { Modal, message } from 'ui';
import { ChatGroupRenameFormContent, type ChatGroupRenameFormValues } from './chat-group-rename-form-content';

type P = {
  chatroomId: string;
  isOpened: boolean;
  name?: string;
  onCancel: () => void;
};

const ChatGroupRenameModal = ({ chatroomId, isOpened, name, onCancel }: P) => {
  const { isPending, mutate: editChatroom } = useEditChatroomMutation();

  const onFinish = (values: ChatGroupRenameFormValues) => {
    editChatroom(
      { chatroomId, name: values.name.trim() },
      {
        onError() {
          message.error("Something went wrong. Chat couldn't be renamed.");
        },
        onSuccess() {
          message.success('Chat renamed successfully');
          onCancel();
        },
      },
    );
  };

  return (
    <Modal isOpened={isOpened} onCancel={onCancel} title="Rename chat" width="small">
      <Modal.HugContent>
        <ChatGroupRenameFormContent isPending={isPending} name={name} onCancel={onCancel} onFinish={onFinish} />
      </Modal.HugContent>
    </Modal>
  );
};

export default ChatGroupRenameModal;
